// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"Carousel_carouselWrapper__gW2W4"};